import {gql} from 'apollo-angular';
export const GET_SCHOOL_CLASS_QUEST = gql`
  query GetSchoolClassQuest($classCode: String!, $userType: QuestUserType!) {
    getSchoolClassQuest(classCode: $classCode, userType: $userType) {
      id
      progress
      completeTasks
      totalTasks
      questTasks {
        id
        taskProgress
        scoreType
        completePoints
        totalPoints
        completeEntries
        totalEntries
        questTask {
          id
          iconNumber
          questTaskType
          taskTitle
          taskTag
          taskDescription
          targetGroup
          taskPoints
          links {
            linkName
            linkValue
            linkType
          }
        }
        taskEntries {
          id

          itemID
        }
      }
      schoolClass {
        id
        schoolClassYear {
          id
        }
      }
      quest {
        id
        remainingTime
        trophyPoints
        interestField {
          id
          interestName
        }
        questTitle
        descriptionText
        questTasks {
          id
          taskTitle
          taskDescription
        }
      }
    }
  }
`;
